var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { cloneElement } from 'react';
import { Card } from '../card';
import { NotificationIcon } from '../notification-icon';
import CloseButton from './close-button';
import { contentStyle, notificationStyle } from './styles';
const decorHighlightVariantMap = {
    error: 'red',
    info: 'blue',
    success: 'green',
    upgrade: 'purple',
    warning: 'orangeLight',
};
function NotificationCardInternal(_a, ref) {
    var { children, closable = false, closeButtonOverride, hideLeftDecor = false, isContentCentered = false, onClose, size = 'medium', variant = 'info' } = _a, restProps = __rest(_a, ["children", "closable", "closeButtonOverride", "hideLeftDecor", "isContentCentered", "onClose", "size", "variant"]);
    function renderCloseButton() {
        function handleClick() {
            var _a, _b;
            (_b = closeButtonOverride === null || closeButtonOverride === void 0 ? void 0 : (_a = closeButtonOverride.props).onClick) === null || _b === void 0 ? void 0 : _b.call(_a);
            onClose === null || onClose === void 0 ? void 0 : onClose();
        }
        if (closable) {
            return closeButtonOverride != null ? (
            // TODO: Replace cloning with context during future refactor - ixTec
            cloneElement(closeButtonOverride, {
                onClick: handleClick,
                size,
            })) : (_jsx(CloseButton, Object.assign({}, { size }, { onClick: onClose })));
        }
        return null;
    }
    return (_jsxs(Card, Object.assign({ css: notificationStyle({ variant }), disableHoverEffect: true, ref: ref, role: "status" }, (!hideLeftDecor && {
        highlightVariant: decorHighlightVariantMap[variant],
        variant: 'highlight',
    }), Object.assign({ size }, restProps), { children: [_jsx(NotificationIcon, Object.assign({}, {
                isCentered: isContentCentered && closable,
                size,
                variant,
            })), _jsx("div", Object.assign({ css: contentStyle({ closable, isContentCentered }) }, { children: children })), renderCloseButton()] })));
}
export default NotificationCardInternal;
